import axios, { AxiosInstance } from 'axios';
import { ApiResponse, ApplyOssStsToken } from '@packages/global';

/**
 * 无认证的 HTTP 客户端（用于报名公开接口）
 */
class PublicHttpClient {
  public readonly instance: AxiosInstance;

  constructor() {
    this.instance = axios.create({
      baseURL: '/api',
      timeout: 30000,
    });
  }

  async get<T>(url: string, params?: any): Promise<T> {
    const response = await this.instance.get<ApiResponse<T>>(url, { params });
    return response.data.data!;
  }

  async post<T>(url: string, data?: any): Promise<T> {
    const response = await this.instance.post<ApiResponse<T>>(url, data);
    return response.data.data!;
  }
}

export const publicHttpClient = new PublicHttpClient();

// Apply 模块 API
export const applyApi = {
  /**
   * 获取 OSS STS 临时凭证（公开接口）
   */
  getStsToken: async (): Promise<ApplyOssStsToken> => {
    return publicHttpClient.get<ApplyOssStsToken>('/apply/sts-token');
  },

  /**
   * 创建报名
   */
  createRegistration: async (data: any) => {
    return publicHttpClient.post<{ registrationId: string; createdAt: string }>('/apply/registrations', data);
  },
};
